export const MILE_TO_METER = 1609.34;

export const convertMileToMeter = (val, decimal_number = 1) => {
  return (val * MILE_TO_METER).toFixed(decimal_number);
};

export const convertMeterToMile = (val, decimal_number = 1) => {
  return (val / MILE_TO_METER).toFixed(decimal_number);
};
